// extracted by mini-css-extract-plugin
module.exports = {"address":"CardShippingAddress__address__Mb8Ei"};